import { Alert, Col, Row } from "antd";
import React, { Component } from "react";
import { connect } from "react-redux";
import {
  ErrorItem,
  Form,
  FormItem,
  InputItem,
  InputNumberItem,
  ModalItem,
  SelectInsumosItem,
  TextAreaItem,
} from "../../../../Components/Items";

// Renglón sin venta: producto que el cliente trae pero que no se puede ligar a una venta
// (por ejemplo, comprado a un distribuidor). Sirve para reemplazo, reparación o rechazo,
// pero nunca para nota de crédito.
class ModalRenglonLibreRMA extends Component {
  formRef = React.createRef();
  insumoElegido = null;

  componentDidUpdate(prevProps) {
    if (this.props.visible && !prevProps.visible) {
      this.insumoElegido = null;
      this.formRef.current?.resetFields();
    }
  }

  async agregar() {
    let valores;
    try {
      valores = await this.formRef.current.validateFields();
    } catch (e) {
      return ErrorItem(e);
    }
    this.props.onAgregar({
      libre: true,
      insumoId: valores.insumoId || undefined,
      codigo: this.insumoElegido?.codigo !== undefined ? String(this.insumoElegido.codigo) : "",
      descripcion: (valores.descripcion || "").trim(),
      cantidadSolicitada: Number(valores.cantidadSolicitada) || 0,
      precioUnitarioNeto: Number(valores.precioUnitarioNeto) || 0,
      factorImpuestos: 1,
      tipoDeCambio: 1,
      observaciones: valores.observaciones || "",
    });
  }

  render() {
    return (
      <ModalItem
        title="Agregar renglón sin venta"
        visible={this.props.visible}
        onCancel={this.props.onCerrar}
        onOk={this.agregar.bind(this)}
        okText="Agregar al RMA"
        footer
        width={window.innerWidth > 1000 ? 640 : "95%"}
        paddingTop
      >
        <Alert
          type="info"
          showIcon
          style={{ marginBottom: 12 }}
          message="Un renglón sin venta no puede llevar nota de crédito: solo reemplazo, reparación o rechazo."
        />
        <Form ref={this.formRef} name="renglonLibreRMA" layoutForm="vertical">
          <FormItem label="Insumo (opcional)" name="insumoId" margin>
            <SelectInsumosItem
              empresaId={this.props.empresaId}
              headersToken={this.props.headersToken}
              placeholder="Busca el insumo si existe en el catálogo"
              width="100%"
              allowClear
              onChange={(insumoId, insumo) => {
                this.insumoElegido = insumo || null;
                this.formRef.current?.setFieldsValue({
                  insumoId,
                  ...(insumo?.descripcion ? { descripcion: insumo.descripcion } : {}),
                });
              }}
            />
          </FormItem>
          <FormItem label="Descripción" name="descripcion" required margin>
            <InputItem placeholder="Qué trae el cliente" />
          </FormItem>
          <Row gutter={16}>
            <Col xs={12}>
              <FormItem label="Cantidad" name="cantidadSolicitada" required margin>
                <InputNumberItem placeholder="0" min={0} style={{ width: "100%" }} />
              </FormItem>
            </Col>
            <Col xs={12}>
              <FormItem
                label="Valor unitario estimado (MXN)"
                name="precioUnitarioNeto"
                tooltip={{ title: "Solo sirve para calcular el monto a autorizar." }}
                margin
              >
                <InputNumberItem placeholder="0.00" min={0} dinero style={{ width: "100%" }} />
              </FormItem>
            </Col>
          </Row>
          <FormItem label="Observaciones" name="observaciones" margin>
            <TextAreaItem rows={2} placeholder="Número de serie, estado en que llega, etc." />
          </FormItem>
        </Form>
      </ModalItem>
    );
  }
}

const mapStateToProps = (state) => ({
  headersToken: state.user.headersToken,
  empresaId: state.empresa.id,
});

export default connect(mapStateToProps)(ModalRenglonLibreRMA);
